/**
 * Mutation-key tag shared by the analytical-dataset write mutations
 * (save / process). Lives in core-constants — not feature-analytical-datasets —
 * so feature-project-page can import it without a build cycle (the AD route
 * constants live here for the same reason).
 *
 * `useProjectPageAnalyticalDatasetSync` (mounted in ProjectPage) subscribes to
 * the TanStack mutation cache and refreshes the project artifact manifest +
 * activity feed on any write tagged with this key — so an AD save/process
 * surfaces in those panels without a manual reload, mirroring the cohort path.
 */
export const ANALYTICAL_DATASET_WRITE_MUTATION_KEY = 'analytical-dataset-write';
